module.exports = __webpack_public_path__ + "assets/pizza_mobile-1c1daa.svg";